export const SCENE_DIMENSIONS = {
    width: 35,
    depth: 25,
    height: 6,
};

export const CAMERA_CONFIG = {
    defaultFOV: 60,
    height: 12.0,
};

export const LIGHTING_CONFIG = {
    ambient: {
        intensity: 0,
        color: "#ffffff"
    },
    spotlights: {
        intensity: 0,
        color: "#ffffff",
        height: 7.5
    },
    wallWash: {
        intensity: 0,
        color: "#ffffff",
        height: 3
    }
}; 